import React from 'react'

export default function LotDetails(props) {
    if(!props.details) return null;
    const detail = props.details;
    return (
        <div>
            <h3 style={{width: '300px', paddingBottom: '6px', fontSize: '16px'}}>{detail.name}</h3>
            <div>
                <img style={{width: '100%', height: '153px'}} src={detail.image_url} />
            </div>  
            <h4>Address:</h4>
            <p>{detail.address}</p>
            <h4>Opening Hours:</h4>
            <p>{detail.opening_hours}</p>
            <h4><span style={{position: 'relative', top: '-5px', color: 'rgb(220, 110, 125)', fontSize: '13px'}}>*</span>Pricing:</h4>
            <div>
                <table>
                    <thead>
                        <tr>
                            <th>Hours</th>
                            <th>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {detail.pricing && detail.pricing.map(item => {
                            return (
                                <tr>
                                    <td>
                                        {item.Hours}
                                    </td>
                                    <td>
                                        {item.Price}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div> 
            {detail.pricing_terms && detail.pricing_terms.map(item => <p style={{fontSize: '12px', marginTop: '10px'}}>{item.value}</p>)}
            <p style={{fontSize: '12px', marginTop: '7.5px'}}>
                <span style={{position: 'relative', top: '-3px', color: 'rgb(220, 110, 125)', fontSize: '15px'}}>*</span> The above is the usual Pricing at this parking lot. However, during long weekends and holidays, this pricing may change. Please refer to the main screen for the details of the most updated pricing details.
            </p>
            <p style={{fontSize: '12px', marginTop: '7.5px'}}>In case of In-and-Out, we do not guarantee a spot.</p>
            <p style={{fontSize: '12px', marginTop: '7.5px'}}>There are no cancellations and refunds possible.</p>
        </div>
    )
}
